import { Integration } from "api/company";
import { ApiLink } from "api/shared";

import IntegrationCard from "components/IntegrationCard";
import IntegrationsContainer from "components/IntegrationsContainer";

interface LinkCompanyContainerProps {
  className?: string;
  integrations: Integration[];
  selectedIntegration?: string;
  onIntegrationSelect: (integrationKey: string) => void;
  link?: ApiLink["link"];
  clientName: string;
}

const LinkCompanyContainer: React.FC<LinkCompanyContainerProps> = ({
  className,
  integrations,
  selectedIntegration,
  onIntegrationSelect,
  link,
  clientName,
}) => (
  <div className={className}>
    <IntegrationsContainer>
      {integrations.map((integration) => (
        <IntegrationCard
          key={integration.key}
          integration={integration}
          active={integration.key === selectedIntegration}
          disabled={integration.clientLimitReached}
          selectedIntegration={selectedIntegration}
          onClick={() => {
            if (integration.key === selectedIntegration) {
              onIntegrationSelect("");
            } else {
              onIntegrationSelect(integration.key);
            }
          }}
          eventProperties={{
            integration: integration.name,
          }}
          data-testid="link-integration-button"
          clientName={clientName}
          link={link}
        />
      ))}
    </IntegrationsContainer>
  </div>
);

export default LinkCompanyContainer;
